import { render } from "./HeaderMenu.vue?vue&type=template&id=2d2611cf&scoped=true&ts=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=ts"
export * from "./HeaderMenu.vue?vue&type=script&lang=ts"

import "./HeaderMenu.vue?vue&type=style&index=0&id=2d2611cf&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2611cf"]])

export default __exports__